/*
*
* File JS componente Block Title Text
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-tabs.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockTabs = () => {
    const allTabs = document.querySelectorAll('.block-tabs__tabs-item');
    if( !allTabs.length ) return;

    const allContent = document.querySelectorAll('.block-tabs__inner');
    if( !allContent.length ) return;

    //INSERISCO LA CLASSE ACTIVE AL PRIMO TAB E AL RELATIVO CONTENUTO
    allTabs[0].classList.add('active');
    const firstContent = document.querySelector(`.block-tabs__inner[data-content="${allTabs[0].dataset.content}"]`);
    firstContent.classList.add('active');


    allTabs.forEach( tab => {
        tab.addEventListener('click', () => {
            allTabs.forEach(tab => tab.classList.remove('active'));
            tab.classList.add('active');
            manageContent(tab);
        });

        tab.addEventListener("keydown", function(event) {
            if (event.key === "Enter") {
                allTabs.forEach(tab => tab.classList.remove('active'));
                tab.classList.add('active');
                manageContent(tab);
            }
        });

    });

    function manageContent(item)
    {
        let activeTab = item.dataset.content;
        const content = document.querySelector(`.block-tabs__inner[data-content="${activeTab}"]`);
        if( !content ) return;

        if (content.classList.contains('active')) {
            allContent.forEach(element => element.classList.remove('active'));
        } else {
            allContent.forEach(element => element.classList.remove('active'));
            content.classList.add('active');
        };
    };
}

export default blockTabs;

//--------------------------------------------------------------------//